import { rest } from 'msw';
import { delay } from '../config';

export const updateUser = [
  rest.put('/api/user/update', (req, res, ctx) => {
    return res(delay(), ctx.status(200));
  }),
];
